import { Route, Switch } from 'react-router-dom';
import DownloadLabel from './components/DownloadLabel/DownloadLabel';
import ItemsList from './components/ItemsList/ItemsList';
import OrderLookup from './components/OrderLookup/OrderLookup';
import { PageNotFound } from './components/PageNotFound';
import { ProtectedRoute } from './components/ProtectedRoute';
import Review from './components/Review/Review';
import { Shipping } from './components/Shipping/Shipping';
import Summary from './components/Summary/Summary';
import { useFirebase } from './firebase/context';

const shopPathPrefix = '/:shop';

export const Routes = () => {
  const firebase = useFirebase();

  const activePrefix = firebase.hasCustomDomain() ? '' : shopPathPrefix;

  return (
    <Switch>
      <Route
        exact
        path={firebase.hasCustomDomain() ? '/' : shopPathPrefix}
        component={OrderLookup}
      />
      <ProtectedRoute exact path={`${activePrefix}/exchange`} component={ItemsList} />
      <ProtectedRoute exact path={`${activePrefix}/shipping`} component={Shipping} />
      <ProtectedRoute exact path={`${activePrefix}/review`} component={Review} />
      <ProtectedRoute exact path={`${activePrefix}/summary`} component={Summary} />
      <ProtectedRoute exact path={`${activePrefix}/download-label`} component={DownloadLabel} />
      <Route path="*" component={PageNotFound} />
    </Switch>
  );
};
